// extracted by mini-css-extract-plugin
module.exports = {"slide":"HorizontalTicker_slide__jwje4","img":"HorizontalTicker_img__PO7V6"};